import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import styled from 'styled-components';
import Media from 'react-responsive';
import {applyState, applyDispatch} from 'utils/redux';
import {initialize, login, loginWithAd} from 'modules/login/actions';
import {loading} from 'modules/login/selectors';
import logoLight from 'assets/images/eniopro1_white.svg';
import logoKattokeskus from 'assets/images/kattokeskus_logo.png';
import {colors, screenMdMin} from 'styles/constants';
import Form from './components/Form';
import View from 'components/generic/View';
import Page from 'components/generic/Page';
import AzureLogin from './components/AzureLogin';
import ContentSeparator from 'components/generic/ContentSeparator';
import Link from 'components/generic/Link';

const desktopQuery = `(min-width: ${screenMdMin})`;

const Row = styled.div`
	flex: 1;
	display: flex;
	flex-direction: row;
	background: #232323;
`;

const LargeLogo = styled.img`
	height: 380px;
	width: auto;
	max-width: 300px;
`;

const Separator = styled(ContentSeparator)`
	border-top: 1px solid ${colors.grey2};
	width: 100%;
`;

const StyledLink = styled(Link)`
	color: ${colors.primary1};
`;

class Login extends React.Component {
	componentDidMount() {
		this.props.initialize();
	}

	render() {
		const {login, loginWithAd, loading} = this.props;

		// TODO: This is whitelisted for now. *.enio.pro and *.dev.enio.pro should use v2 for azure. Could be handled with organization metadata.
		const azureAuthUrl = window.location.hostname.startsWith('kattokeskus')
			? '/auth/v2/social/azure/kattokeskus'
			: '/auth/social/azure';

		const leftLogoSrc = window.location.hostname.startsWith('kattokeskus')
			? logoKattokeskus
			: logoLight;

		const azureLoginButtonVariant = window.location.hostname.startsWith('kattokeskus')
			? 'red'
			: 'green';

		return (
			<View>
				<Page>
					<Row>
						<div className="flex-1 bg-gray-900 flex items-center justify-center">
							<div className="flex flex-col items-center justify-center max-w-[400px] min-w-[300px] mx-auto my-auto p-12">
								<img
									src={leftLogoSrc}
									alt="logo"
									className="w-auto h-auto max-h-28 mb-8 mx-6"
								/>
								<AzureLogin
									loginWithAd={() => loginWithAd(azureAuthUrl)}
									loading={loading}
									buttonVariant={azureLoginButtonVariant}
								/>
								<Separator />
								<Form onSubmit={() => login()} loading={loading} />
								<Separator />
								{/* TODO: The country selection is whitelisted for now. Could be handled with organization metadata. */}
								{window.location.hostname.endsWith('renoa.pro') && (
									<StyledLink href="//renoa.pro/country-select">
										Country selection
									</StyledLink>
								)}
							</div>
						</div>
						<Media query={desktopQuery}>
							<div className="flex-1 bg-gray-800 flex items-center justify-center">
								<LargeLogo src={logoLight} alt="eniopro-logo-large" />
							</div>
						</Media>
					</Row>
				</Page>
			</View>
		);
	}
}

Login.propTypes = {
	initialize: propTypes.func,
	login: propTypes.func,
	loginWithAd: propTypes.func,
	loading: propTypes.bool,
};

export default connect(
	applyState({loading}),
	applyDispatch({initialize, login, loginWithAd}),
)(Login);
